import './index.erb';
import './index.rb';
import 'plyr/dist/plyr.css';
import Plyr from 'plyr';

function initializeQuestionAnswerModal() {
  'use strict';
  const $modal = $('#js-question-answer-modal');

  if ($modal.length === 0) {
    return;
  }

  if ($modal.data('plyr-initialized')) {
    return;
  }

  $modal.data('plyr-initialized', true);

  const $closeBtn = $modal.find('#js-question-answer-modal-close');
  const $closeBtnIcon = $closeBtn.find('.q-icon');
  const $closeBtnText = $closeBtn.find('.btn-text');
  const $progressBar = $modal.find('.progress-bar');
  const $video = $modal.find('video');

  // Overlay
  const $overlay = $modal.find('#player-overlay');
  const $overlayIcon = $modal.find('.overlay-icon-container .overlay-icon');
  const $overlayText = $modal.find('#overlay-text');

  // Variáveis de estado
  let progressCompleted = false;
  let progressInterval;
  let watchedTime = 0;
  let videoEnded = false;
  const totalRequiredTime = 10;

  const player = new Plyr($video[0], {
    controls: [],
    fullscreen: { enabled: false },
    muted: true
  });

  // video error
  player.on('error', err => {
    $closeBtn.removeAttr('disabled');
    $closeBtnIcon.show();
    $closeBtnText.text('Fechar');

    $progressBar.parent().hide();

    $overlay.removeClass('hidden');

    $overlayIcon
      .removeClass('q-icon-play q-icon-undo q-icon-volume-mute')
      .addClass('q-icon-times');

    $overlayText.text('Não foi possível carregar o vídeo');

    $overlay.css('pointer-events', 'none');

    // eslint-disable-next-line no-console
    console.warn('Erro fatal no vídeo:', err);
  });

  $video.on('dblclick', e => {
    e.preventDefault();
    e.stopPropagation();
  });

  function setIcon(iconClass) {
    $overlayIcon
      .removeClass('q-icon-play q-icon-undo q-icon-volume-mute q-icon-times')
      .addClass(iconClass);
  }

  function updateOverlay() {
    if (!player) {
      return;
    }

    const isMuted = player.muted;
    const isPaused = player.paused;

    if (videoEnded) {
      $overlay.removeClass('hidden');
      setIcon('q-icon-undo');
      $overlayText.text('Assistir novamente');
    } else if (isPaused) {
      $overlay.removeClass('hidden');
      setIcon('q-icon-play');
      $overlayText.text('Vídeo pausado');
    } else if (isMuted) {
      $overlay.removeClass('hidden');
      setIcon('q-icon-volume-mute');
      $overlayText.text('Clique para ativar o som');
    } else {
      $overlay.addClass('hidden');
    }
  }

  // Clique no overlay: desmuta, despausa ou reinicia
  $overlay.on('click', () => {
    if ($overlayIcon.hasClass('q-icon-times')) {
      return;
    }

    if (videoEnded) {
      videoEnded = false;
      player.restart();
      player.play().catch(err => {
        // eslint-disable-next-line no-console
        console.warn('Erro ao reiniciar vídeo:', err);
      });
    } else {
      if (player.muted) {
        player.muted = false;
        player.volume = 1;
      }

      if (player.paused) {
        player.play().catch(err => {
          // eslint-disable-next-line no-console
          console.warn('Erro ao tocar vídeo:', err);
        });
      }
    }

    updateOverlay();
  });

  function tryPlayVideo() {
    player
      .play()
      .then(() => {
        updateOverlay();
      })
      .catch(err => {
        // eslint-disable-next-line no-console
        console.warn('Autoplay modal soft falhou:', err);
      });
  }

  // OPEN MODAL
  $modal.on('shown.bs.modal', () => {
    if ($video.find('source').length === 0) {
      $closeBtn.removeAttr('disabled');
      $closeBtnIcon.show();
      $closeBtnText.text('Fechar');

      $overlay.removeClass('hidden');
      setIcon('q-icon-times');
      $overlayText.text('Ops! Ocorreu um erro ao carregar o vídeo');
      return;
    }

    player.muted = true;
    $closeBtnIcon.hide();
    $closeBtnText.text(`Aguarde... (${totalRequiredTime})`);

    tryPlayVideo();
  });

  // CLOSE MODAL
  $modal.on('hidden.bs.modal', () => {
    player.stop();

    // Reseta estado
    clearInterval(progressInterval);
    progressInterval = null;
    watchedTime = 0;
    videoEnded = false;
    progressCompleted = false;
    $progressBar.parent().show();
    $overlay.css('pointer-events', '');

    $progressBar.css('width', '0%');
    $closeBtn.attr('disabled', true);
    $closeBtnIcon.hide();
    $closeBtnText.text(`Aguarde... (${totalRequiredTime})`);

    $overlay.addClass('hidden');
    $overlayText.text('Vídeo pausado');
    setIcon('q-icon-play');
  });

  // PLAYER EVENTS
  player.on('play', () => {
    updateOverlay();

    if (progressCompleted) {
      return;
    }

    $closeBtn.attr('disabled', true);

    clearInterval(progressInterval);

    $closeBtnIcon.hide();

    progressInterval = setInterval(() => {
      watchedTime += 0.1;

      const progress = Math.min((watchedTime / totalRequiredTime) * 100, 100);
      const remainingTime = Math.ceil(totalRequiredTime - watchedTime);

      $progressBar.css('width', `${progress}%`);
      $closeBtnText.text(`Aguarde... (${remainingTime})`);

      if (progress >= 100) {
        clearInterval(progressInterval);
        progressInterval = null;
        progressCompleted = true;
        $closeBtn.removeAttr('disabled');
        $closeBtnIcon.show();
        $closeBtnText.text('Continuar estudando');
      }
    }, 100);
  });

  player.on('pause', () => {
    updateOverlay();
    clearInterval(progressInterval);
    progressInterval = null;
  });

  player.on('volumechange', updateOverlay);

  // Vídeo terminou
  player.on('ended', () => {
    videoEnded = true;
    clearInterval(progressInterval);
    progressInterval = null;
    updateOverlay();
  });
}

document.addEventListener('turbolinks:load', initializeQuestionAnswerModal);
initializeQuestionAnswerModal();
